import { TypedBackendError, ValidationError } from '../types/types';

export const ALLOWED_BACKEND_ERROR_TYPES = [
    'Default',
    'Validation',
    'Extendable',
    'ListValidation',
    'Aggregated',
    'ServerError',
] satisfies (TypedBackendError['type'])[];

export function isTypedBackendError(error: unknown): error is TypedBackendError {
    return (
        !!error &&
        typeof error === 'object' &&
        'type' in error &&
        typeof error.type === 'string' &&
        ALLOWED_BACKEND_ERROR_TYPES.includes(error.type as TypedBackendError['type'])
    );
}

export function isValidationBackendError(error: unknown): error is ValidationError {
    return isTypedBackendError(error) && error?.type === 'Validation';
}
